export default __webpack_public_path__ + "static/media/Untitled design.e342c8c9.png";